export const AnalysisPhysician = {
    path: '/analysis/physician',
    name: 'analysis.physician',
    component: () => import('@/views/Analysis/AnalysisPhysician.vue')
}